import { render, staticRenderFns } from "./deleteRule.vue?vue&type=template&id=6b4536ea&scoped=true&"
import script from "./deleteRule.vue?vue&type=script&lang=js&"
export * from "./deleteRule.vue?vue&type=script&lang=js&"
import style0 from "./deleteRule.vue?vue&type=style&index=0&id=6b4536ea&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b4536ea",
  null
  
)

export default component.exports